import AxiosConfig from '../config/axios-config'
/* Remover esse defaultParams das chamadas quando a passagem do empresaId estiver funcionando pelo axios-config.js */
const defaultParams = {
  params: {
    empresaId: process.env.VUE_APP_EMPRESA_REF
  }
}

export default {

  enviarRelatoProblema (ementaId, texto, categoriaRelato, url) {
    return AxiosConfig.secureJalekoAPI().post(`/relato-problema/ementa/${ementaId}`, { texto, categoriaRelato, url }, defaultParams).then(response => response.data)
  }

}
